/** Restore leading zeros lost when an IMC number is stored as an integer. */
export function formatImcNumber(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '';

  const imcNumber = String(value);
  return /^[0-9]+$/.test(imcNumber) ? imcNumber.padStart(6, '0') : imcNumber;
}
